import {createPinia} from 'pinia'
export const stores = createPinia()

